export default __webpack_public_path__ + "images/EM.27b6cba.png";